import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IUserCreation, IUserProfile } from "./userProfile.types";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ISearchQueryParams } from "../store.types";
import { getSearchQueryFromParams, getSearchQueryParams } from "../store.utils";

export const FETCH_USERS_LIST_PROGRESS = "FETCH_USERS_LIST_PROGRESS";
export const FETCH_USERS_LIST_SUCCESS = "FETCH_USERS_LIST_SUCCESS";
export const FETCH_USERS_LIST_FAILED = "FETCH_USERS_LIST_FAILED";

export const fetchUsersListProgress = () => action(FETCH_USERS_LIST_PROGRESS);
export const fetchUsersListSuccess = (
  data: IUserProfile[],
  totalRecords: number,
  currentRecords: number,
  meta: { use_count: number; created_count: number },
) =>
  action(FETCH_USERS_LIST_SUCCESS, {
    data: data,
    totalRecords,
    currentRecords,
    meta,
  });
export const fetchUsersListFailed = () => action(FETCH_USERS_LIST_FAILED);

export const fetchUsersListAsync =
  (
    params: ISearchQueryParams,
    // pageNumber: number,
    // rowsInPerPage: number,
    // limit: number,
    // status: string,
    // date: IDate,
    // searchValue: string,
    // searchType: string[],
    // company_outlet_uuid?: string,
    // role_uuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchUsersListProgress());

      const searchQuery = getSearchQueryFromParams(params);

      const res = await api.get(`/user/get-user${searchQuery}`);

      const data: IUserProfile[] = res.data.data;
      dispatch(
        fetchUsersListSuccess(
          data,
          res.data.totalRecords,
          res.data.currentRecords,
          res.data.meta,
        ),
      );
    } catch (err: any) {
      dispatch(fetchUsersListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_USERS_PROGRESS = "FETCH_USERS_PROGRESS";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILED = "FETCH_USERS_FAILED";

export const fetchUsersProgress = () => action(FETCH_USERS_PROGRESS);
export const fetchUsersSuccess = (data: IUserProfile) =>
  action(FETCH_USERS_SUCCESS, { data: data });
export const fetchUsersFailed = (errorMessage: string) =>
  action(FETCH_USERS_FAILED, { errorMessage });

export const fetchUsersAsync =
  (
    userId: string,
    company_outlet_uuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchUsersProgress());
      let url = `/user/get-user?user_uuid=${userId}`;
      if (company_outlet_uuid) {
        url += `&company_outlet_uuid=${company_outlet_uuid}`;
      }
      const res = await api.get(url);
      const data = res.data.data;
      if (data) {
        dispatch(fetchUsersSuccess(data[data.length - 1]));
      } else {
        dispatch(
          fetchUsersFailed(
            "Unfortunately, there are no records available at the moment.",
          ),
        );
      }
    } catch (err: any) {
      dispatch(fetchUsersFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const upsertUserAysnc =
  (
    user: IUserProfile,
    file: File | null,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const userProfile = getState().userprofile.users.user;
      const {
        user_fact_id,
        user_dim_id,
        csr,
        csr_code,
        user_profile_id,
        producer_one,
        producer_one_code,
        producer_two,
        producer_two_code,
        producer_three,
        producer_three_code,
        marketer,
        marketer_code,

        ...rest
      } = user;

      // if (file) {
      // 	const path = await uploadFile(file, "USER", user.photo || "", {
      // 		title: user.first_name,
      // 	});
      // 	rest.photo = path;
      // }
      // if (userProfile.role_uuid !== user.role_uuid) {
      //   await api.post("/user/change-user-role", {
      //     user_uuid: user.user_uuid,
      //     role_uuid: user.role_uuid,
      //     role_value: user.role_value,
      //   });
      // }

      await api.post("/user/update-profile", rest);

      dispatch(
        showMessage({
          type: "success",
          message: "User profile is updated successfully",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const createNewUserAsync =
  (
    user: IUserCreation,
    onCallback: (isSuccess: boolean, user_fact_id?: number) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { confirmPassword, ...rest } = user;
      const res = await api.post("/user/upsert-user", rest);

      dispatch(
        showMessage({
          type: "success",
          message: "User is created successfully",
          displayAs: "snackbar",
        }),
      );
      onCallback(true, res.data.data.user_uuid);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

// *************reset password actions *******************
export const generateOTP =
  (
    email: string,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post("/authentication/generate-otp", {
        email: email,
        otp_for: "FORGET_PASSWORD",
      });

      dispatch(
        showMessage({
          type: "success",
          message: "OTP send successfully.",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const changeForgotPassword =
  (
    data: {
      email: string;
      otp: string;
      user_password: string;
      action: string;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post("/authentication/forget-password", data);

      dispatch(
        showMessage({
          type: "success",
          message: "Password changed successfully.",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
export const changePasswordByAdmin =
  (
    data: {
      user_uuid: string;
      user_password: string;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post("/user/change-user-pwd", data);

      dispatch(
        showMessage({
          type: "success",
          message: "Password changed successfully.",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
